export type OrganizationAssignmentSource = (
  "user"
  | "organization_defaults"
  | "external_organizations"
)


export const ORGANIZATION_FRIENDLY_ASSIGNMENT_SOURCES: {[key: string]: string} = {
  user: "User",
  identity_pool_defaults: "Identity Pool Defaults",
  external_organizations: "External Organizations",
};
